
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import PaginatedWrittenReviewResourceView from '@/mixins/PaginatedWrittenReviewResourceView';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
import ReviewContentType from '@/enums/ReviewContentType';
import AccessLevel from '@/enums/AccessLevel';

export default {
  i18nComponentKey: 'ManagingReviews.components.WrittenReviews',
  name: 'WrittenReviews',
  mixins: [PaginatedWrittenReviewResourceView],
  computed: {
    ...mapState(['api']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('widget', ['widget']),
    ...mapGetters('widget', ['isMobileViewport']),
    ...mapGetters('review', ['showDate', 'showEditOrDelete']),
    DropdownMenuWidth: () => DropdownMenuWidth,
    AccessLevel: () => AccessLevel,
    defaultResourceParams() {
      return {
        widget_id: this.widget.id,
        managing_reviews: true,
        fields: [
          'reviews.evaluation_properties',
          'reviews.with_parent_reviews',
          'reviews.customer_properties',
          this.reviewSettings.use_comments &&
          this.reviewSettings.always_show_comments
            ? 'reviews.comments'
            : ''
        ]
          .filter(v => v)
          .join(',')
      };
    },
    mileageStyle() {
      return {
        '--background-color': this.widget.my_review_mileage_background_color,
        '--text-color': this.widget.my_review_mileage_text_color
      };
    }
  },
  created() {
    this.SET_EDIT_OR_DELETE_CALLBACK(() => this.searchResource());
  },
  beforeDestroy() {
    this.SET_EDIT_OR_DELETE_CALLBACK(null);
  },
  methods: {
    ...mapActions('review', [
      'fetchManagingReviewsWrittenReviews',
      'handleEditOrDeleteReview'
    ]),
    ...mapActions('widget', ['openShowReviewPopup']),
    ...mapMutations('review', ['SET_EDIT_OR_DELETE_CALLBACK']),
    showMileageSection(review) {
      return (
        this.widget.show_written_reviews_mileage_section &&
        review.mileage.gave_mileage_at
      );
    },
    editOrDeleteOptions(review) {
      return [
        review.editable
          ? { name: this.$t('app.edit_review'), value: 'edit' }
          : null,
        review.deletable
          ? {
              name: this.$t('app.delete_review'),
              value: 'delete',
              danger: true
            }
          : null
      ].filter(v => v);
    },
    displayMediaSection(review) {
      return (
        review.content_type !== ReviewContentType.RESTRICTED &&
        review.media_count > 0
      );
    },
    mileageMessage(review) {
      const mileageMessagePrefix = review.mileage.gave_mileage_amount
        ? this.$t('gave_mileage_message', {
            mileage_amount: review.mileage.gave_mileage_amount
          })
        : '';
      const mileageMessage = review.mileage.calculated_mileage_reasons.join(
        ', '
      );

      return `${mileageMessagePrefix} ${mileageMessage}`;
    },
    fetchResource(params) {
      this.isLoadingReviews = true;
      const resourceParams = { ...this.defaultResourceParams, ...params };
      this.fetchManagingReviewsWrittenReviews({
        params: resourceParams
      }).finally(() => (this.isLoadingReviews = false));
    },
    reviewHiddenMessage(review) {
      if (review.is_admin_hide) {
        return this.$t('hidden_by_admin_message');
      } else if (review.is_profane) {
        return this.$t('hidden_by_system_message');
      } else if (review.is_require_confirmation) {
        return this.$t('hidden_by_before_confirmation_message');
      } else if (review.is_sentiment_analyzed) {
        return this.$t('hidden_by_system_message');
      } else if (review.is_display_after_ai_analysis) {
        return this.$t('hidden_by_before_confirmation_message');
      }
      return this.$t('hidden_by_system_message');
    }
  }
};
